import { module } from 'modujs';
import modularLoad from 'modularload';
import { html } from '../utils/environment'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.load = new modularLoad({
            enterDelay: 900,
            transitions: {
                pagination: {
                    enterDelay: 0,
                    exitDelay: 0
                },
                products: {
                    enterDelay: 0,
                    exitDelay: 0
                }
            }
        });

        this.load.on('loaded', (transition, oldContainer, newContainer) => {
            this.call('destroy', oldContainer, 'app');
            this.call('update', newContainer, 'app');

            if(transition === 'pagination') {
                html.classList.remove('has-spinner-active');

                setTimeout(() => {
                    this.call('update', null, 'Scroll')
                },700)
            }

            if(transition === 'products') {
                html.classList.remove('has-spinner-active');
                html.classList.remove('has-footer-visible');

                let target;

                if(document.querySelector('[data-transition-scroll-target]')) {
                    target = newContainer.querySelector('[data-transition-scroll-target]')
                } else {
                    target = 'top'
                }

                this.call('scrollTo', { target: target, options: { duration: 1, offset: -80 }}, 'Scroll');

                setTimeout(() => {
                    this.call('update', null, 'Scroll')
                },700)
            }

            //Update analytics (send page view events)
            window?.ShopifyAnalytics?.lib?.page();
        });

        this.load.on('loading', (transition, oldContainer) => {
            this.call('closeMenu', null, 'Menu');
            this.call('closeOverlay', null, 'CategorieButton');
            this.call('close', null, 'Search');
            html.classList.remove('has-footer-visible');

            if(transition === 'pagination') {
                this.call('scrollTo', { target: oldContainer, options: { duration: 1, offset: -100 }}, 'Scroll');

                html.classList.add('has-spinner-active');
            }

            if(transition === 'products') {
                html.classList.add('has-spinner-active');
            }
        });

        this.load.on("ready", (transition, newContainer) => {
            this.reloadForKlayio();
        });
    }

    goTo(obj) {
        const { url , transition } = obj

        this.load?.goTo(url, transition);
    }

    /**
     * Force reload if the is a klaviyo form on the page
     *
     */
    reloadForKlayio(){
        const klaviyoForms = Array.from(document.querySelectorAll('.c-wysiwyg [class^="klaviyo-form"]'));

        if(klaviyoForms.length > 0) {
            window.location.reload();
        }
    }
}
